import { glyphs } from "../../../Styles";

export const contents = (
  func_add: () => void,
  func_edit: () => void,
  func_cancel: () => void,
  func_save: () => void,
  label_add: string,
  label_edit: string,
  label_cancel: string,
  label_save: string,
  editTable: boolean
): [string[], JSX.Element[], (() => void)[]] => {
  const buttonEntries: { label: string; glyphs: JSX.Element; onClick: () => void; }[] = [];
  
  if (editTable) {
    buttonEntries.push(
      { label: label_save, glyphs: glyphs.Check({}), onClick: func_save },
      { label: label_cancel, glyphs: glyphs.Close({}), onClick: func_cancel },
    );
  }
    
  buttonEntries.push(
    { label: label_add, glyphs: glyphs.Add({}), onClick: func_add },
    { label: label_edit, glyphs: glyphs.Edit({}), onClick: func_edit }
  );

  const labels = buttonEntries.map((b) => b.label);
  const icons = buttonEntries.map((b) => b.glyphs)
  const onclicks = buttonEntries.map((b) => b.onClick);
  return [labels, icons, onclicks];
};